// Recipe page: split the written recipe into an ingredients card and numbered directions
(() => {
  const page = document.querySelector('.recipe-page');
  const content = page?.querySelector('[data-recipe-content]');
  if (!page || !content) return;
  const ingredientsRe = /^ingredients?\s*:?$/i;
  const directionsRe = /^(method|directions?|instructions?|steps?|preparation)\s*:?$/i;
  const labels = { ingredients: page.dataset.ingredientsLabel, directions: page.dataset.directionsLabel };

  // The outermost element whose whole text is just this heading
  const findHeading = (re) => {
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const text = walker.currentNode.textContent.trim();
      if (!re.test(text)) continue;
      let el = walker.currentNode.parentElement;
      while (el.parentElement && el.parentElement !== content && re.test(el.parentElement.textContent.trim())) el = el.parentElement;
      return el;
    }
    return null;
  };

  const tidy = (fragment) => {
    fragment.querySelectorAll('[data-canva-clipboard], script, style').forEach(n => n.remove());
    return fragment;
  };
  const isEmpty = (node) => !node.textContent.trim() && !node.querySelector('img');

  // Ingredients as a bulleted list: one item per ingredient, keeping preparation notes with their item
  const prep = /^(finely|roughly|coarsely|thinly|freshly|lightly|cubed|chopped|sliced|diced|minced|crushed|grated|peeled|slivered|halved|quartered|mashed|melted|softened|beaten|divided|optional|to taste|for (garnish|serving|frying|dusting|greasing)|plus|cut|toasted|roasted|soaked|drained|rinsed|deseeded|deveined|tops|seeds|stems|skin|at room|or |and )/i;
  const splitIngredients = (text) => {
    const parts = [];
    let depth = 0, current = '';
    for (const ch of text.replace(/\s+/g, ' ')) {
      if (ch === '(') depth++;
      if (ch === ')') depth = Math.max(0, depth - 1);
      if ((ch === ',' || ch === '\n' || ch === ';') && depth === 0) { parts.push(current.trim()); current = ''; } else current += ch;
    }
    parts.push(current.trim());
    const items = [];
    parts.filter(Boolean).forEach(part => {
      if (items.length && prep.test(part)) items[items.length - 1] += ', ' + part; else items.push(part);
    });
    return items;
  };
  const buildIngredients = (fragment) => {
    const holder = document.createElement('div');
    holder.append(fragment);
    const ul = document.createElement('ul');
    ul.className = 'recipe-page__ingredients';
    let items = [...holder.querySelectorAll('li')].map(n => n.textContent.trim()).filter(Boolean);
    if (!items.length) items = splitIngredients(holder.innerText || holder.textContent);
    items.forEach(text => { const li = document.createElement('li'); li.textContent = text; ul.append(li); });
    return ul;
  };
  const split = () => {
    const ing = findHeading(ingredientsRe);
    const dir = findHeading(directionsRe);
    if (!ing || !dir || !(ing.compareDocumentPosition(dir) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;

    const range = document.createRange();
    range.setStartAfter(ing); range.setEndBefore(dir);
    const ingFragment = tidy(range.extractContents());
    const dirRange = document.createRange();
    dirRange.setStartAfter(dir); dirRange.setEnd(content, content.childNodes.length);
    const dirFragment = tidy(dirRange.extractContents());

    // Text before "Ingredients" is the description, already shown at the top
    const introRange = document.createRange();
    introRange.setStart(content, 0); introRange.setEndBefore(ing);
    introRange.deleteContents();

    const ingCard = document.createElement('div');
    ingCard.className = 'recipe-page__card';
    const h2 = document.createElement('h2');
    h2.textContent = labels.ingredients || ing.textContent.trim();
    ingCard.append(h2);
    ingCard.append(buildIngredients(ingFragment));

    // Directions: one step per list item or paragraph; a single paragraph is split by sentence
    let steps = [...dirFragment.querySelectorAll('li')].map(n => n.textContent.trim()).filter(Boolean);
    if (!steps.length) {
      const holder = document.createElement('div'); holder.append(dirFragment);
      steps = [...holder.querySelectorAll('p')].map(n => n.textContent.trim()).filter(Boolean);
      if (!steps.length) steps = [holder.textContent.trim()].filter(Boolean);
      if (steps.length === 1) steps = steps[0].split(/(?<=[.!?])\s+(?=[A-Z0-9])/).map(s => s.trim()).filter(Boolean);
    }
    const dirBlock = document.createElement('div');
    dirBlock.className = 'recipe-page__directions';
    const h = document.createElement('h2');
    h.textContent = labels.directions || dir.textContent.trim();
    const ol = document.createElement('ol');
    ol.className = 'recipe-page__steps';
    steps.forEach((text, i) => {
      const li = document.createElement('li');
      li.className = 'recipe-page__step';
      const num = document.createElement('span'); num.className = 'recipe-page__num'; num.textContent = i + 1;
      const p = document.createElement('p'); p.textContent = text;
      li.append(num, p); ol.append(li);
    });
    dirBlock.append(h, ol);

    const grid = document.createElement('div');
    grid.className = 'recipe-page__grid';
    grid.append(ingCard, dirBlock);
    content.replaceChildren(grid);
    content.classList.add('is-split');
    return true;
  };
  // Posts with the ingredient and direction fields are already built by the theme; older posts are split here
  if (!content.hasAttribute('data-structured')) { try { split(); } catch (e) { /* keep the plain text card */ } }
})();